import { render, staticRenderFns } from "./InternationalPayments.vue?vue&type=template&id=0039fec2"
import script from "./InternationalPayments.vue?vue&type=script&lang=js"
export * from "./InternationalPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports